import React, { Component } from 'react';
import {Row, Col, Button, ButtonGroup} from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import AddForm from './components/AddForm';
import Table from './components/Table';
import API from '../../services/API';
import Icon from "../../components/Icon";
import SyncMessage from "../../components/SyncMessage";

class AdkBlock extends Component {
    constructor() {
        super();

        this.state = {
            affidValues: [],
            report: [],
            sortParam: null,
            sortOrder: 1,
            filters: {},
            isLoading: false,
            isShowForm: false,
            syncData: null
        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleAddFormHide = this.handleAddFormHide.bind(this);
        this.handleAddFormSubmit = this.handleAddFormSubmit.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRemoveBtnClick = this.handleRemoveBtnClick.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handleSync = this.handleSync.bind(this);
    }

    componentDidMount() {
        API.AdkFeeds.getIds()
            .then(affids => this.setState({ affidValues: affids }));
    }

    componentWillUpdate(nextProps, nextState) {
        const { report, sortParam, sortOrder } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(report, sortParam, sortOrder);

            this.setState({ report });
        }
    }

    sortReport(report, sortParam, sortOrder) {
        report.sort((objA, objB) => {
            if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
            else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

            return 0;
        });
    }

    handleSync() {
        this.setState({ isLoading: true });

        API.Sync([ 'adk-EU', 'adk-US', 'adk-SG' ], 'block')
            .then((res) => {
                this.setState({ isLoading: false, syncData: { res } });

                setTimeout(() => this.setState({ syncData: null }), 10000);
            })
            .catch(err => {
                this.setState({ isLoading: false, syncData: { reqErr: err } });
                setTimeout(() => this.setState({ syncData: null }), 10000);
            });
    }
    
    handleAddBtnClick() {
        this.setState({ isShowForm: true });
    }

    handleAddFormHide() {
        this.setState({ isShowForm: false });
    }

    handleAddFormSubmit({ affid, subids }) {
        this.setState({
            isShowForm: false,
            isLoading: true
        });

        API.AdkBlock.save(affid, subids.split(','))
            .then(() => this.setState({ isLoading: false }));
    }

    handleSubmit(filters) {
        this.setState({ isLoading: true, filters });

        this.loadBlock(filters);
    }

    loadBlock(filters = this.state.filters) {
        API.AdkBlock.get(filters).then(({ report }) => this.setState({ report, isLoading: false }));
    }

    handleRemoveBtnClick(id) {
        this.setState({ isLoading: true });

        API.AdkBlock.remove(id).then(() => this.loadBlock());
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    getTable() {
        const { report, reportTotal } = this.state;

        return report.length ?
            <Table report={report} total={reportTotal} onSortChange={this.handleSort} onRemove={this.handleRemoveBtnClick} /> :
            <p>No Data</p>
    }


    getForm() {
        if(this.state.isShowForm) {
            return <AddForm
                affids={this.state.affidValues}
                onSubmit={this.handleAddFormSubmit}
                onFormHide={this.handleAddFormHide}
            />;
        }
    }

    render() {
        const { isLoading, affidValues } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="ADK Block"/>
                <Row>
                    <Col lg={12}>
                        <ButtonGroup className="pull-right m-b-15">
                            <Button bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                            <Button bsStyle="info" onClick={this.handleSync}> Sync</Button>
                        </ButtonGroup>
                    </Col>
                </Row>
                <SyncMessage {...this.state.syncData} />

                <Form onSubmit={this.handleSubmit} affidValues={affidValues}/>
                {this.getForm()}
                {this.getTable()}
            </Container>
        );
    }
}

export default AdkBlock;



// WEBPACK FOOTER //
// ./src/scenes/AdkBlock/index.js